import { parseEventLocatorKey, resolveEventIndex } from '../utils/dateHelpers';

export function parseDroppableId(id) {
    const parsed = parseEventLocatorKey(id);
    return {
        date: parsed.date,
        eventName: parsed.eventName,
        gId: parsed.gId,
        calendarId: parsed.calendarId,
    };
}

export function indexFromDraggableId(draggableId) {
    const m = String(draggableId).match(/::(\d+)$/);
    return m ? parseInt(m[1], 10) : null;
}

export function createOnDragEnd({ eventsByDate, updateEventStaff, updateNeededForEvent, activeCalendarId }) {
    return function onDragEnd(result) {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        const s = parseDroppableId(source.droppableId);
        const d = parseDroppableId(destination.droppableId);

        const srcList = eventsByDate?.[s.date] || [];
        const dstList = eventsByDate?.[d.date] || [];

        const srcEventIdx = resolveEventIndex(srcList, {
            gId: s.gId,
            eventName: s.eventName,
            calendarId: s.calendarId || "",
        });
        const dstEventIdx = resolveEventIndex(dstList, {
            gId: d.gId,
            eventName: d.eventName,
            calendarId: d.calendarId || "",
        });
        if (srcEventIdx < 0 || dstEventIdx < 0) return;

        const srcEvent = srcList[srcEventIdx];
        const dstEvent = dstList[dstEventIdx];

        const j = indexFromDraggableId(draggableId);
        if (j == null) return;

        const srcStaff = [...(srcEvent.staff || [])];
        const [moved] = srcStaff.splice(j, 1);

        const sameBucket =
            s.date === d.date &&
            (s.gId && d.gId
                ? s.gId === d.gId
                : s.eventName === d.eventName) &&
            (s.calendarId || "") === (d.calendarId || "");

        if (sameBucket) {
            const dstIndex = destination.index;
            srcStaff.splice(dstIndex, 0, moved);
            const srcId = srcEvent.gId ? srcEvent : s.eventName;
            updateEventStaff(s.date, srcId, srcStaff, s.calendarId || activeCalendarId, true);
            return;
        }

        const dstStaff = [...(dstEvent.staff || [])];
        const dstIndex = destination.index;
        dstStaff.splice(dstIndex, 0, moved);

        const srcId = srcEvent.gId ? srcEvent : s.eventName;
        const dstId = dstEvent.gId ? dstEvent : d.eventName;
        updateEventStaff(s.date, srcId, srcStaff, s.calendarId || activeCalendarId, true);
        updateEventStaff(d.date, dstId, dstStaff, d.calendarId || activeCalendarId, true);

        const dstNeeded = Math.max(1, Number(dstEvent.needed || 1), dstStaff.length);
        if (dstNeeded !== Number(dstEvent.needed || 1)) {
            const dstNeededRef = dstEvent.gId
                ? { gId: dstEvent.gId, event: dstEvent.event, calendarId: dstEvent.calendarId }
                : { event: dstEvent.event, calendarId: d.calendarId || dstEvent.calendarId || activeCalendarId };
            updateNeededForEvent(d.date, dstNeededRef, dstNeeded, d.calendarId || activeCalendarId, true);
        }
    };
}
